/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
// This is needed for 365 image

import LinksComponent1 from './components/links1';
import LinksComponent2 from './components/links2';
import LinksComponent3 from './components/links3';
import LinksComponent4 from './components/links4';
import LinksComponent5 from './components/links5';
import LinksComponent6 from './components/links6';
import LinksComponent7 from './components/links7';
import LinksComponent8 from './components/links8';

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienFfData } from './obrien-ff.data';
import { IObrienFfProps } from './obrien-ff.props.autogenerated';

export interface IObrienFfViewProps extends IObrienFfProps<IObrienFfData> {

    obFFTitle1?: React.ReactNode;
    obFFTitle2?: React.ReactNode;
    obFFTitle3?: React.ReactNode;
    obFFTitle4?: React.ReactNode;
    obFFTitle5?: React.ReactNode;
    obFFTitle6?: React.ReactNode;
    obFFTitle7?: React.ReactNode;
    obFFTitle8?: React.ReactNode;
    obFFContent1: string;
    obFFContent2: string;
    obFFContent3: string;
    obFFContent4: string;
    obFFContent5: string;
    obFFContent6: string;
    obFFContent7: string;
    obFFContent8: string;
    obFFImage1: React.ReactNode;
    obFFImage2: React.ReactNode;
    obFFImage3: React.ReactNode;
    obFFImage4: React.ReactNode;
    obFFImage5: React.ReactNode;
    obFFImage6: React.ReactNode;
    obFFImage7: React.ReactNode;
    obFFImage8: React.ReactNode;
    links1?: React.ReactNode;
    links2?: React.ReactNode;
    links3?: React.ReactNode;
    links4?: React.ReactNode;
    links5?: React.ReactNode;
    links6?: React.ReactNode;
    links7?: React.ReactNode;
    links8?: React.ReactNode;

}

/**
 *
 * ObrienFf component
 * @extends {React.PureComponent<IObrienFfProps<IObrienFfData>>}
 */
class ObrienFf extends React.PureComponent<IObrienFfProps<IObrienFfData>> {
    public render(): JSX.Element | null {

        const { 
            obFFTitle1,
            obFFTitle2,
            obFFTitle3,
            obFFTitle4,
            obFFTitle5,
            obFFTitle6,
            obFFTitle7,
            obFFTitle8,
            obFFContent1,
            obFFContent2,
            obFFContent3,
            obFFContent4,
            obFFContent5,
            obFFContent6,
            obFFContent7,
            obFFContent8,
            obFFImage1,
            obFFImage2,
            obFFImage3,
            obFFImage4,
            obFFImage5,
            obFFImage6,
            obFFImage7,
            obFFImage8,
            links1,
            links2,
            links3,
            links4,
            links5,
            links6,
            links7,
            links8,
            
        } = this.props.config;

        const ObFFTitle1 = obFFTitle1 && (
            <Msdyn365.Text
              tag={obFFTitle1.tag || 'h2'}
              text={obFFTitle1.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange1, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle2 = obFFTitle2 && (
            <Msdyn365.Text
              tag={obFFTitle2.tag || 'h2'}
              text={obFFTitle2.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange2, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle3 = obFFTitle3 && (
            <Msdyn365.Text
              tag={obFFTitle3.tag || 'h2'}
              text={obFFTitle3.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange3, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle4 = obFFTitle4 && (
            <Msdyn365.Text
              tag={obFFTitle4.tag || 'h2'}
              text={obFFTitle4.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange4, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle5 = obFFTitle5 && (
            <Msdyn365.Text
              tag={obFFTitle5.tag || 'h2'}
              text={obFFTitle5.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange5, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle6 = obFFTitle6 && (
            <Msdyn365.Text
              tag={obFFTitle6.tag || 'h2'}
              text={obFFTitle6.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange6, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle7 = obFFTitle7 && (
            <Msdyn365.Text
              tag={obFFTitle7.tag || 'h2'}
              text={obFFTitle7.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange7, requestContext:this.props.context.request}}
            />
        );
        const ObFFTitle8 = obFFTitle8 && (
            <Msdyn365.Text
              tag={obFFTitle8.tag || 'h2'}
              text={obFFTitle8.text}
              className='ff-heading'
              editProps={{onEdit: this.handleTextChange8, requestContext:this.props.context.request}}
            />
        );

        const ObFFContent1 = obFFContent1 && (
            <Msdyn365.RichTextComponent
                text={obFFContent1}
                editProps={{ onEdit: this.handleParagraphChange1, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent2 = obFFContent2 && (
            <Msdyn365.RichTextComponent
                text={obFFContent2}
                editProps={{ onEdit: this.handleParagraphChange2, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent3 = obFFContent3 && (
            <Msdyn365.RichTextComponent
                text={obFFContent3}
                editProps={{ onEdit: this.handleParagraphChange3, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent4 = obFFContent4 && (
            <Msdyn365.RichTextComponent
                text={obFFContent4}
                editProps={{ onEdit: this.handleParagraphChange4, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent5 = obFFContent5 && (
            <Msdyn365.RichTextComponent
                text={obFFContent5}
                editProps={{ onEdit: this.handleParagraphChange5, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent6 = obFFContent6 && (
            <Msdyn365.RichTextComponent
                text={obFFContent6}
                editProps={{ onEdit: this.handleParagraphChange6, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent7 = obFFContent7 && (
            <Msdyn365.RichTextComponent
                text={obFFContent7}
                editProps={{ onEdit: this.handleParagraphChange7, requestContext: this.props.context.request }}
            />
        );
        const ObFFContent8 = obFFContent8 && (
            <Msdyn365.RichTextComponent
                text={obFFContent8}
                editProps={{ onEdit: this.handleParagraphChange8, requestContext: this.props.context.request }}
            />
        );

        const imageProps1 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage1 && obFFImage1.imageSettings,
        };
        const imageProps2 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage2 && obFFImage2.imageSettings,
        };
        const imageProps3 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage3 && obFFImage3.imageSettings,
        };
        const imageProps4 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage4 && obFFImage4.imageSettings,
        };
        const imageProps5 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage5 && obFFImage5.imageSettings,
        };
        const imageProps6 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage6 && obFFImage6.imageSettings,
        };
        const imageProps7 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage7 && obFFImage7.imageSettings,
        };
        const imageProps8 = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obFFImage8 && obFFImage8.imageSettings,
        };

        const ffImage1 = obFFImage1 && (
            <Msdyn365.Image {...obFFImage1} {...imageProps1} editProps ={{key:this.props.config.obFFImage1 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage2 = obFFImage2 && (
            <Msdyn365.Image {...obFFImage2} {...imageProps2} editProps ={{key:this.props.config.obFFImage2 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage3 = obFFImage3 && (
            <Msdyn365.Image {...obFFImage3} {...imageProps3} editProps ={{key:this.props.config.obFFImage3 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage4 = obFFImage4 && (
            <Msdyn365.Image {...obFFImage4} {...imageProps4} editProps ={{key:this.props.config.obFFImage4 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage5 = obFFImage5 && (
            <Msdyn365.Image {...obFFImage5} {...imageProps5} editProps ={{key:this.props.config.obFFImage5 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage6 = obFFImage6 && (
            <Msdyn365.Image {...obFFImage6} {...imageProps6} editProps ={{key:this.props.config.obFFImage6 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage7 = obFFImage7 && (
            <Msdyn365.Image {...obFFImage7} {...imageProps7} editProps ={{key:this.props.config.obFFImage7 || {}, requestContext: this.props.context.request}}/>
        );
        const ffImage8 = obFFImage8 && (
            <Msdyn365.Image {...obFFImage8} {...imageProps8} editProps ={{key:this.props.config.obFFImage8 || {}, requestContext: this.props.context.request}}/>
        );

        const contentBlockLinks1 = links1 && links1.length > 0 && <LinksComponent1 {...{ links1 }} />;
        const contentBlockLinks2 = links2 && links2.length > 0 && <LinksComponent2 {...{ links2 }} />;
        const contentBlockLinks3 = links3 && links3.length > 0 && <LinksComponent3 {...{ links3 }} />;
        const contentBlockLinks4 = links4 && links4.length > 0 && <LinksComponent4 {...{ links4 }} />;
        const contentBlockLinks5 = links5 && links5.length > 0 && <LinksComponent5 {...{ links5 }} />;
        const contentBlockLinks6 = links6 && links6.length > 0 && <LinksComponent6 {...{ links6 }} />;
        const contentBlockLinks7 = links7 && links7.length > 0 && <LinksComponent7 {...{ links7 }} />;
        const contentBlockLinks8 = links8 && links8.length > 0 && <LinksComponent8 {...{ links8 }} />;

       
        
        const ObrienFFProps = {
            ...this.props,
            obFFTitle1: ObFFTitle1,
            obFFTitle2: ObFFTitle2,
            obFFTitle3: ObFFTitle3,
            obFFTitle4: ObFFTitle4,
            obFFTitle5: ObFFTitle5,
            obFFTitle6: ObFFTitle6,
            obFFTitle7: ObFFTitle7,
            obFFTitle8: ObFFTitle8,
            obFFContent1: ObFFContent1,
            obFFContent2: ObFFContent2,
            obFFContent3: ObFFContent3,
            obFFContent4: ObFFContent4,
            obFFContent5: ObFFContent5,
            obFFContent6: ObFFContent6,
            obFFContent7: ObFFContent7,
            obFFContent8: ObFFContent8,
            obFFImage1: ffImage1,
            obFFImage2: ffImage2,
            obFFImage3: ffImage3,
            obFFImage4: ffImage4,
            obFFImage5: ffImage5,
            obFFImage6: ffImage6,
            obFFImage7: ffImage7,
            obFFImage8: ffImage8,
            links1: contentBlockLinks1,
            links2: contentBlockLinks2,
            links3: contentBlockLinks3,
            links4: contentBlockLinks4,
            links5: contentBlockLinks5,
            links6: contentBlockLinks6,
            links7: contentBlockLinks7,
            links8: contentBlockLinks8
        };

        return this.props.renderView(ObrienFFProps) as React.ReactElement;
    }
    public handleTextChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle1!.text = event.target.value;
    public handleTextChange2 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle2!.text = event.target.value;
    public handleTextChange3 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle3!.text = event.target.value;
    public handleTextChange4 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle4!.text = event.target.value;
    public handleTextChange5 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle5!.text = event.target.value;
    public handleTextChange6 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle6!.text = event.target.value;
    public handleTextChange7 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle7!.text = event.target.value;
    public handleTextChange8 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFTitle8!.text = event.target.value;
    public handleParagraphChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent1! = event.target.value;
    public handleParagraphChange2 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent2! = event.target.value;
    public handleParagraphChange3 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent3! = event.target.value;
    public handleParagraphChange4 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent4! = event.target.value;
    public handleParagraphChange5 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent5! = event.target.value;
    public handleParagraphChange6 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent6! = event.target.value;
    public handleParagraphChange7 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent7! = event.target.value;
    public handleParagraphChange8 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obFFContent8! = event.target.value;
}

export default ObrienFf;
